import { VNROUTES_CLEAR_ROUTE, VNROUTES_SET_ROUTE } from './ActionTypes'

const getInitialState = () => {
  return {
    route: null,
    params: null,
  }
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case VNROUTES_SET_ROUTE:
      return {
        ...state,
        route: action.route,
        params: action.params,
      }
    case VNROUTES_CLEAR_ROUTE:
      return {
        ...state,
        ...getInitialState(),
      }
    default:
      return state
  }
}

export default reducer
